<template>
    <!-- Employees Business Profile -->
    <div class="page-layout blank contacts-manage">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                </div>
            </div>
        </div>
        <div class="pb-10" v-if="!ajaxCallinprogress">
            <!-- <h2 class="headerblock" style=""> -->
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <!-- <a href="javascript:;" class="btn btn-secondary btn-smm hidden-md-down" v-on:click="editCompanyProfile()">
                                <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                                Edit
                </a> -->
                    <div class="breadcrumbnew">
                        <!-- <a>Call Report</a>-->
                        <span @click="$router.go(-1)">Basic info</span>
                        <!-- <span>Company Info</span> -->
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                    <!-- <div class="breadcome-heading d-none d-xl-inline">
                  <div class="form-group formsearch has-warning has-feedback">
                    <input type="text" class="form-control textremove holder" id="inputWarning2" aria-describedby="inputWarning2Status" placeholder="Search..."> -->
                    <!-- <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span> -->
                    <!-- <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                  </div>
                </div> -->
                    <!-- <router-link :disabled="!$routerHistory.hasForward()" :to="{ path: $routerHistory.next().path }">
                  <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward" placement="top">
                    <button class="btn btn-new-grey btn-fab-dc mr-3">
                      <i class="icons icon-arrow-right"></i>
                    </button>
                  </el-tooltip>
                </router-link> -->
                    <!-- <router-link :disabled="!$routerHistory.hasPrevious()" :to="{ path: $routerHistory.previous().path }">
                  <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back" placement="top">
                    <button class="btn btn-new-grey btn-fab-dc mr-3">
                      <i class="icons icon-arrow-left"></i>
                    </button>
                  </el-tooltip>
                </router-link> -->
                </div>
            </div>
            <!-- </h2> -->
            <div class="profile-block">
                <!-- <a href="javascript:;" class="btn btn-secondary btn-smm hidden-md-down"
                    v-on:click="showAddEmployee()">
                        + Add New Contact
                    </a> -->
                <!-- <div class="cover-pic" style="border-radius: 15px 15px 0px 0px;">
                        <img :src="userProfile" class="h-100 w-100" style="border-radius: 15px 15px 0px 0px;">
                        <div class="row align-items-center">
                            <img class="avatar huge coverPicIcon" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dell.jpg" style="z-index: 1;border: 3px solid #c6dbf3;">
                        </div>
                    </div> -->
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block"
                    style="border-radius: 15px;overflow: auto;">
                    <div class="left-side-div">
                        <div class="digi-sidebar digi-left-positioned digi-open digi-locked-open">
                            <div class="cover-card">
                                <img class="cover-card-img-top w-full" :src="profile_data.cover_pic||userProfile"
                                    alt="Cover Pic" style="height: 180px;">
                                <div class="cover-card-block wall-person-info">
                                    <a class="person-avatar bg-white pro-img-bordered">
                                        <img class="businesslogoimg"
                                            :src="profile_data.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                            :alt="businessData.full_name">
                                    </a>
                                </div>
                            </div>
                            <div class="digi-content-block px-4 py-2 mt-10">
                                <div class="header pt-4">
                                    <div class="contactInfo">
                                        <div>
                                            <span
                                                class="text-white fw-600 fs-18 contactTitle">{{ businessData.full_name }}</span>
                                            <!-- <div class="mt-2 contactTitle">
                                                    <img class="CompanyContact mr-1 mb-1" src="/static/images/crm/icons/phone-white.svg">
                                                    <span>
                                                        charlie@gmail.com
                                                    </span>
                                                </div> -->
                                            <div class="mt-2 contactTitle">
                                                <!-- <img class="CompanyContact mr-1 mb-1" src="/static/images/crm/icons/phone-white.svg"> -->
                                                <i class="crmnew-envelope mr-1 mb-1 text-white iconsize-14"></i>
                                                <span v-if="businessData.primary_email">
                                                    {{ businessData.primary_email.value }}
                                                </span>
                                            </div>
                                            <div class="mt-2 contactTitle" v-if="businessData.phone_number">
                                                <!-- <img class="CompanyContact" src="/static/images/crm/icons/phone-white.svg"> -->
                                                <i class="crmnew-phone mr-1 mb-1 text-white iconsize-14"></i>
                                                <span>
                                                    {{businessData.primary_phone.value.phone_number }}
                                                </span>
                                            </div>
                                            <!-- <div class="widget widget6 card pt-2 pb-3 mt-5" style="box-shadow: none;border-radius: 10px;border: solid 0.5px #fff;background-image: linear-gradient(to right, #0086f8, #1c78f2 47%, #2d70ee);">
                            <div class="widget-content">
                              <div class="row no-gutters">
                                <div class="col-4 d-flex flex-column align-items-center justify-content-center" @click="goToConnections('employee')">
                                  <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_small.svg" alt="Connection" style="width: 14px;margin-right:4px;">
                                      {{ connectionCount || 0 }}
                                  </div>
                                  <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 600;">Connections</div>
                                </div>
                                <div class="col-3 d-flex flex-column align-items-center justify-content-center">
                                  <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/followers_small.svg" alt="Followers" style="width: 13px;margin-right:4px;">
                                    0
                                  </div>
                                  <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 600;">Followers</div>
                                </div>
                                <div class="col-4 d-flex flex-column align-items-center justify-content-center ">
                                  <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/following_small.svg" alt="Following" style="width: 13px;margin-right:4px;">
                                    0
                                  </div>
                                  <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 600;">Following</div>
                                </div>
                                <div class="col-1 d-flex flex-column align-items-center justify-content-center">
                                  <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_router_arrow.svg" alt="Arrow" style="width: 10px;">
                                </div>
                              </div>
                            </div>
                          </div> -->
                                            <div class="widget widget6 card pt-3 pb-3 mt-5"
                                                style="box-shadow: none;border-radius: 10px;border: solid 0.5px #1eabe5;background-color: #29c2e0;">
                                                <div class="widget-content">
                                                    <div class="row no-gutters" style="cursor: pointer;">
                                                        <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center"
                                                            style="border-bottom: 1px solid #1ca7e6;"
                                                            @click="goToConnections">
                                                            <div class="connectionbox">
                                                                <div class="connection_pic">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_small.svg"
                                                                        alt="Connetions" />
                                                                </div>
                                                                <div class="connection_details">
                                                                    <div class="count h2 text-white mb-1"
                                                                        style="line-height: 1.19;font-size: 16px;">
                                                                        {{ connectionCount.connections_count || 0 }}
                                                                    </div>
                                                                    <div class="count-title text-white"
                                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">
                                                                        Connections</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center"
                                                            style="border-bottom: 1px solid #1ca7e6;"
                                                            @click="goToFollowers">
                                                            <div class="connectionbox">
                                                                <div class="connection_pic">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/followers_small.svg"
                                                                        alt="Followers" />
                                                                </div>
                                                                <div class="connection_details">
                                                                    <div class="count h2 text-white mb-1"
                                                                        style="line-height: 1.19;font-size: 16px;">
                                                                        {{ connectionCount.followers_count || 0 }}
                                                                    </div>
                                                                    <div class="count-title text-white"
                                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">
                                                                        Followers</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center"
                                                            @click="goToFollowing">
                                                            <div class="connectionbox">
                                                                <div class="connection_pic">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/following_small.svg"
                                                                        alt="Following" />
                                                                </div>
                                                                <div class="connection_details">
                                                                    <div class="count h2 text-white mb-1"
                                                                        style="line-height: 1.19;font-size: 16px;">
                                                                        {{ connectionCount.following_count || 0 }}
                                                                    </div>
                                                                    <div class="count-title text-white"
                                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">
                                                                        Following</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="text-center mt-4 mb-3">
                                                    <i class="icon icon-facebook text-white contactMediaView mediaFacebook" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                    <i class="icon icon-twitter text-white contactMediaView mediaTwitter ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                    <i class="icon icon-skype text-white contactMediaView mediaSkype ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                </div>  -->
                                            <div class="mt-6 contactTitle" v-if="loggedInUser._id!=$route.params.id">
                                                <div class="">
                                                    <!-- <a class="btn btn-warning btn-smm text-white mx-4 mb-3" v-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_by==loggedInUser._id&&account==connectionStatus.sender_company&&connectionStatus.sent_to==$route.params.id" @click="changeConnectionStatus('delete', connectionStatus._id)">Request Sent</!-->
                                                    <span
                                                        v-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_by==loggedInUser._id&&connectionStatus.sent_to==this.businessData.user_id">
                                                        <button type="button"
                                                            class="btn btn-warning btn-smm text-white mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatusType('delete', connectionStatus._id)">REQUEST
                                                            SENT</button>
                                                        <button type="button"
                                                            class="btn btn-warning btn-smm text-white mx-4 mb-3 disabledbutton"
                                                            v-else>REQUEST SENT</button>
                                                    </span>

                                                    <span v-else-if="connectionStatus.connection_status=='connected'">
                                                        <button type="button" class="btn btn-danger btn-smm mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatusType('disconnected', connectionStatus._id)">DISCONNECT</button>
                                                        <button type="button"
                                                            class="btn btn-danger btn-smm mx-4 mb-3 disabledbutton"
                                                            v-else>DISCONNECT</button>
                                                    </span>
                                                    <!-- <button type="button" class="btn btn-outline-success btn-smm text-success mx-4 mb-3" v-else-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_to==loggedInUser._id&&account==connectionStatus.receiver_company&&connectionStatus.sent_by==$route.params.id" @click="changeConnectionStatus('connected',connectionStatus._id)">Pending</button> -->
                                                    <span
                                                        v-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_to==loggedInUser._id&&connectionStatus.sent_by!=$route.params.id">
                                                        <button type="button"
                                                            class="btn btn-grey-outline btn-smm mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatusType('connected',connectionStatus._id)">PENDING</button>
                                                        <button type="button"
                                                            class="btn btn-grey-outline btn-smm mx-4 mb-3 disabledbutton"
                                                            v-else>PENDING</button>
                                                    </span>
                                                    <span
                                                        v-if="businessData.user_id != loggedInUser._id&&!connectionStatus.connection_status">
                                                        <button type="button"
                                                            class="btn btn-success btn-smm text-white mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="sendBusinessRequest()">CONNECT</button>
                                                        <button type="button"
                                                            class="btn btn-success btn-smm text-white mx-4 mb-3 disabledbutton"
                                                            v-else>CONNECT</button>
                                                    </span>
                                                    <span
                                                        v-if="businessData.user_id != loggedInUser._id && (admin || superAdmin)">
                                                        <a class="btn btn-danger btn-smm mx-4 mb-3"
                                                            v-if="businessData.active_status == 'active'"
                                                            @click="changeEmployeeStatusTerminate">TERMINATE</a>
                                                        <!-- <a class="btn btn-danger btn-smm mx-4 mb-3 disabledbutton" v-else>TERMINATE</a> -->
                                                    </span>
                                                    <!-- <button type="button" class="btn btn-pink-new btn-smm mx-4 mb-3 text-uppercase" @click="inviteUser">Invite</button> -->
                                                    <!-- <button type="button" class="btn btn-secondary btn-smm mx-4 mb-3">Follow</button> -->
                                                    <!-- <button type="button" class="btn btn-secondary btn-smm mx-4 mb-3">Unfollow</button> -->
                                                </div>
                                            </div>
                                            <!-- <hr class="" style="border-top: 1px solid rgba(255, 255, 255, 0.2);">
                              <h5 class="fs-14 pt-4 pb-3 text-center">Scan Code</h5>
                              <div class="qrcode-block-view mt-3">
                                  <img src="/static/images/qr-logo-dg.svg" class="qr-logo-view">
                                  <qrcode-vue :value="valueqr" :size="size" level="H" background="#d6e2ef" foreground="#00448b" class="qrcode-content-view"></qrcode-vue>
                              </div> -->
                                        </div>
                                        <hr style="border-top: 2px solid rgba(255, 255, 255, 0.5);" class="mt-5 mb-3">
                                        <div class="profile-list business-list-info">
                                            <div class="profile-list-item" @click="changeModelView('employeeInfoView')">
                                                <div class="profile-wrapper"
                                                    v-bind:class="{ selected: employeeInformation}">
                                                    <img class="profile-images"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/info.svg">
                                                </div>
                                                <div class="profile-name">Info</div>
                                            </div>
                                            <div class="profile-list-item" v-if="account==$route.params.company_id"
                                                @click="changeModelView('employeeProView')">
                                                <div class="profile-wrapper"
                                                    v-bind:class="{ selected: employeeProducts}">
                                                    <img class="profile-images" alt="Products"
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/products.svg">
                                                </div>
                                                <div class="profile-name">Products</div>

                                            </div>
                                            <div style="width: 100%;" class="qrcode-whole-div">
                                                <div class="qrcode-block-view mt-6">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/qr-logo-dg.svg"
                                                        class="qr-logo-view">
                                                    <!-- <qrcode-vue :value="valueqr" :size="size" level="H" background="#fff" foreground="#005dae" class="qrcode-content-view"></qrcode-vue> -->
                                                    <qrcode-vue value="Hello" level="H" background="#fff"
                                                        foreground="#005dae" class="qrcode-content-view"></qrcode-vue>
                                                </div>
                                            </div>
                                        </div>
                                        <h5 class="fs-16 pt-4 pb-3 text-center text-white fw-600">Scan Code</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center-section" style="border-radius: 15px;min-width: 60em;" v-if="employeeInformation">
                        <div class="center-content">
                            <div class="infoHeader px-3 py-3" style="background: transparent;">
                                <div class="descriptionheader p-0">
                                    <div class="description-text-header-left pl-2">
                                        <h5 style="color: #303031;">
                                            Information Overview
                                        </h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <a href="javascript:;" class="btn btn-secondary btn-smm"
                                            @click="editEmployeeProfile()"
                                            v-if="account==$route.params.company_id && (admin || superAdmin)"
                                            v-show="activateEditMode == false">
                                            <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                                            Edit
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="preview-elements px-3">
                                <div class="tab-content profile-tab-content" id="myTabContent"
                                    style="max-height: 70em;">
                                    <div class="" id="basictab" aria-labelledby="basic-tab">
                                        <employee-basic-view v-if="!activateEditMode" :businessData="businessData">
                                        </employee-basic-view>
                                        <edit-employee-basic-view v-else @deactivateEditMode="deactivateEditMode">
                                        </edit-employee-basic-view>
                                        <!-- <div class="tabs-content-firstblock mb-4">
                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="infoHeader ml-2 mr-1">
                                    <div class="descriptionheader">
                                      <div class="description-text-header-left">
                                        <h5>
                                          <i class="crmnew-basic iconsize-16 pr-1 defaultBlue"></i>
                                          Basic Information
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="ml-2 mr-1">
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="a-q-Jc-j-contactView mt-1">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">First Name</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView font-color">
                                                {{ businessData.first_name }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Middle Name</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView text-runcate">
                                                {{ businessData.middle_name || "-" }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Last Name</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.last_name }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Gender</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.user.gender }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Date of Birth<br>(dd/mm/yyyy)</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{  moment(businessData.user.date_of_birth).format('DD/MM/YYYY')}}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Blood Group</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.user.blood_group || '-' }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Personal Email</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.user.primary_email }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Business Email</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.email_id }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="a-q-Jc-j-contactView">
                                          <div class="a-q-Jc-Pj-Ya-contactView" style="border-bottom: solid 1px transparent !important;">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Phone Number</div>
                                            <div class="a-q-Jc-Lb-contactView">
                                              <span class="a-q-Jc-wg-contactView">
                                                {{ businessData.user.primary_phone.phone_number }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center-section" style="border-radius: 15px;min-width: 60em;" v-if="employeeProducts">
                        <div class="center-content">
                            <div class="preview-elements px-4 py-6">
                                <admin-products :businessData="businessData"></admin-products>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QrcodeVue from "qrcode.vue";
    import {
        User
    } from "./mixins/user";
    import Connection from "./mixins/connection";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import myUpload from "vue-image-crop-upload";
    import moment from "moment";
    import EmployeeBasicView from "./EmployeeBasicView";
    import EditEmployeeBasicView from "./EditEmployeeBasicView";
    import AdminProducts from "./AdminProducts";
    import {
        HalfCircleSpinner
    } from 'epic-spinners';
    import {
        EmployeeManage
    } from "./mixins/employees";
    export default {
        data() {
            return {
                show: false,
                userProfile: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
                headers: {
                    smail: "*_~",
                },
                connectionStatus: {
                    connection_status: null
                },
                searchkey: "",
                businessData: {},
                moment: moment,
                connectionCount: "",
                disabledBtn: false,
                requestResponse: false,
                employeeInformation: true,
                employeeProducts: false,
                activateEditMode: false,
                ajaxCallinprogress: false,
                employeeData: [],
            };
        },
        components: {
            "my-upload": myUpload,
            moment,
            EmployeeBasicView,
            EditEmployeeBasicView,
            AdminProducts,
            HalfCircleSpinner,
            QrcodeVue
        },
        mixins: [User, Connection, EmployeeManage],
        methods: {
            toggleBtn() {
                this.toggleSideBar = !this.toggleSideBar;
            },
            toggleBtn1() {
                this.toggleSideBar = false;
            },
            toggleShow() {
                this.show = !this.show;
            },
            cropSuccess(userProfile, field) {
                this.userProfile = userProfile;
            },
            cropUploadSuccess(jsonData, field) {},
            cropUploadFail(status, field) {},
            showEditMap() {
                this.$modal.show("edit_address_modal");
            },

            // Connection Page Redirection with permission
            goToConnections(employee) {
                if (this.loggedInUser._id == this.$route.params.id) {
                    var request_type = "business";
                    if (this.account) {
                        request_type = "employee";
                    }
                    this.$router.push({
                        name: "ConnectionList",
                        params: {
                            id: this.$route.params.id,
                            request_type: request_type
                        },
                    });
                    // EventBus.$emit("Employee", "employee");
                }
            },
            goToFollowers() {
                if (this.loggedInUser._id == this.$route.params.id) {
                    this.$router.push({
                        name: "FollowerList"
                    });
                }
            },
            goToFollowing() {
                if (this.loggedInUser._id == this.$route.params.id) {
                    this.$router.push({
                        name: "FollowingList"
                    });
                }
            },

            // Get Employee Data in Business Profile
            getEmployeeData() {
                this.ajaxCallinprogress = true;
                var request_type = "business";
                if (this.account) {
                    request_type = "employee";
                }
                this.$http
                    .post("employees/get_employee_data", {
                        emp_id: this.$route.params.id,
                        company_id: this.$route.params.id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.businessData = response.data.response;
                            this.ajaxCallinprogress = false;
                            this.getConnectionStatus({
                                user_id: this.businessData.user_id,
                                request_type: request_type,
                                company_id: this.businessData.company_id,
                            });
                            this.getConnectionsCount(this.$route.params.id)
                        }
                    })
                    .catch(error => {});
            },

            // Checking Connection Count
            async getConnectionsCount(id) {
                let res = await this.$http.get("/connections/connection_count?id=" + id);
                if (res.data.status_id == 1) {
                    this.connectionCount = res.data.response;
                }
            },

            // Employee Business Details
            async getEmployeeDetails() {
                let response = await this.getEmployeeDetailsAPI({
                    emp_id: this.$route.params.id,
                });
                this.businessData = response.response;
            },

            // Sending Connection Request
            async sendBusinessRequest() {
                this.requestResponse = true
                var request_type = "business";
                if (this.account) {
                    request_type = "employee";
                }
                let response = await this.sendBusinessRequestAPI({
                    sent_to: this.businessData.user_id,
                    isCompany: true,
                    request_type: request_type,
                    receiver_company: this.businessData.company_id,
                });
                if (response) {
                    this.requestResponse = false
                    this.getEmployeeData();
                    this.$awn.success("Request Sent Successfully");
                }
            },

            // Checking Connection Status API
            getConnectionStatusType(params) {
                if (this.loggedInUser._id != params.user_id) {
                    this.$http
                        .post("/connections/get_connection_status", params)
                        .then(res => {
                            if (res.data.status_id == 1) {
                                if (res.data.response) this.connectionStatus = res.data.response;
                                else this.connectionStatus = {
                                    connection_status: null
                                };
                            }
                        });
                }
            },

            // Checking Connection Status Actions
            changeConnectionStatusType(status, id) {
                this.requestResponse = true
                this.$http
                    .post("/connections/change_connection_status", {
                        connection_status: status,
                        _id: id,
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.requestResponse = false
                            this.getConnectionsCount(id);
                            this.getConnectionStatusType({
                                user_id: this.businessData.user_id,
                                request_type: "employee",
                            });
                            if (status == "disconnected") {
                                this.$awn.success("Request Disconnected Successfully");
                            }
                            if (status == "delete") {
                                this.$awn.success("Request Deleted Successfully");
                            }
                            if (status == "connected") {
                                this.$awn.success("Request Accepted Successfully");
                            }
                        }
                    });
                this.disabledBtn = false
            },

            // Business Employee Terminate Function
            changeEmployeeStatusTerminate() {
                this.requestResponse = true
                this.$http
                    .post("/employees/change_employee_status", {
                        status: "terminated",
                        employee_id: this.$route.params.id,
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.requestResponse = false
                            this.$awn.success("Employee Terminated Successfully")
                            this.getEmployees("terminated");
                            this.getEmployeeData();
                            //this.getUserEmployeeRequest();
                        } else {
                            this.$swal({
                                title: "Error!",
                                text: "Please try again",
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        }
                    });
            },
            // Editing Employee Activation
            editEmployeeProfile() {
                this.activateEditMode = true;
                // this.$router.push({
                //   name: "EditEmployee",
                //   params: { id: this.$route.params.id },
                // });
            },
            // Deactivate Edit Mode
            deactivateEditMode(data) {
                this.businessData = data;
                this.activateEditMode = false;
            },
            // Changing Tab Views
            changeModelView(viewName) {
                if (viewName == "employeeInfoView") {
                    if (this.activateEditMode == false) {
                        this.employeeInformation = true;
                        this.employeeProducts = false;
                    } else {
                        this.$swal({
                            title: "WARNING !",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.employeeInformation = true;
                                this.employeeProducts = false;
                                this.activateEditMode = false;
                            }
                        });
                    }
                } else if (viewName == "employeeProView") {
                    if (this.activateEditMode == false) {
                        this.employeeInformation = false;
                        this.employeeProducts = true;
                    } else {
                        this.$swal({
                            title: "WARNING !",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.employeeInformation = false;
                                this.employeeProducts = true;
                                this.activateEditMode = false;
                            }
                        });
                    }
                }
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            account() {
                return this.$store.getters.account;
            },
            admin() {
                return this.$store.getters.isAdmin;
            },
            superAdmin() {
                return this.$store.getters.isSuperAdmin;
            },
        },
        created() {
            this.getEmployeeData();
            this.getEmployees("terminated");
            if (this.$route.params.id) {
                this.getConnectionsCount(this.$route.params.id);
            } else {
                this.getConnectionsCount(this.loggedInUser._id);
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.activateEditMode = false;
            this.employeeInformation = true;
            this.employeeProducts = false;
            const id = to.params.id;
            // this.GetUserData(id);
            this.getConnectionsCount(id);
            next();
        },
    };
</script>
<style>
    .profile-block {
        /* border: 1px solid #e0e3e6; */
        border-radius: 15px;
        /* margin: 15px 15px 30px; */
        width: 100%;
        /* background: #eaeaec; */
    }

    .page-layout-new {
        position: relative;
        overflow: hidden;
    }

    .page-layout-new.simple-new {
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        width: 100%;
        min-width: 100%;
        border-radius: 15px 15px 15px 15px;
        color: #fff;
        /* border: 1px solid #00448b; */
    }

    /* background-image: linear-gradient(180deg,#eaeaec,#f7f7f8 15%,#f7f7f8 34%,#fff 48%,#f7f7f8 62%,#f7f7f8 85%,hsla(240,5%,92%,.8)); */
    .page-layout-new.simple-new.left-sidebar-block,
    .page-layout-new.simple-new.right-sidebar-block {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        flex-direction: row;
    }

    .page-layout-new.simple-new.left-sidebar-block>.left-side-div,
    .page-layout-new.simple-new.right-sidebar-block>.right-side-div {
        /* background: 0 0; */
        background: transparent;
        box-shadow: none;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar {
        width: 240px;
        min-width: 240px;
        max-width: 240px;
        overflow: hidden;
    }

    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar {
        -webkit-box-ordinal-group: 3;
        order: 2;
    }

    .digi-sidebar {
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        position: absolute;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        width: 350px !important;
        min-width: 350px !important;
        max-width: 350px !important;
    }

    .digi-sidebar.digi-left-positioned {
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        border: solid 0.5px #005dae;
        background-color: #005dae !important;
        border-radius: 15px;
    }

    .digi-sidebar.digi-right-positioned {
        right: 0;
        -webkit-transform: translateX(100%);
        transform: translateX(100%);
    }

    .digi-sidebar.digi-open {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }

    .digi-sidebar.digi-locked-open {
        position: relative !important;
        -webkit-transform: translateX(0) !important;
        transform: translateX(0) !important;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar .digi-content-block,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar .digi-content-block {
        -webkit-box-flex: 1;
        flex: 1 1 auto;
    }

    .page-layout-new.simple-new.left-sidebar-block>.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.center-section {
        position: relative;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 1 auto;
        z-index: 3;
        min-width: 0;
        width: 100%;
        /* padding: 6px; */
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar.digi-locked-open+.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar.digi-locked-open+.center-section {
        z-index: 1001;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar.digi-locked-open.digi-left-positioned+.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar.digi-locked-open.digi-left-positioned+.center-section {
        margin-left: 0;
    }

    .page-layout-new.simple-new.left-sidebar-block>.center-section>.center-content,
    .page-layout-new.simple-new.right-sidebar-block>.center-section>.center-content {
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        color: #303031;
    }

    @-moz-document url-prefix() {
        .coverPicIcon {
            margin-top: 123px;
        }

        .mediaIcon {
            top: 19% !important;
        }
    }

    .contactInfo {
        margin-top: 10px;
        display: block;
        justify-content: center;
        align-items: center;
        margin-bottom: 10%;
        position: relative;
        color: #00448b;
    }

    .companyBackground {
        border-right: solid 1px #94bef0;
        background-image: linear-gradient(to bottom,
                #eaeaec,
                #f7f7f8 15%,
                #ffffff 34%,
                #ffffff 48%,
                #ffffff 62%,
                #f7f7f8 85%,
                rgba(234, 234, 236, 0.8));
    }

    .CompanyContact {
        width: 14.2px;
        height: 10.8px;
    }

    .headerTitleView {
        width: 357px;
        height: 40px;
        border-radius: 100px;
        background-color: #f2f2f2;
        margin-top: 15px;
        display: inline-block;
    }

    .contactActiveTab {
        color: #00448b !important;
        border-top: 18px solid transparent;
        border-bottom: 18px solid transparent;
        border-right: solid 18px #cdd2da;
        background-color: #f1f1f1;
        border-right-color: #ffffff;
        overflow: inherit !important;
        padding-left: 45px !important;
    }

    .info:hover {
        color: #00448b;
    }

    .info {
        margin-right: 40px;
    }

    .a-q-Jc-Pj-Ya-contactView {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        line-height: 30px;
    }

    .a-q-Jc-Pj-Ya-contactView {
        line-height: 25px;
        padding: 16px 10px 16px 3px;
        /* border-bottom: solid 1px #707070; */
    }

    .a-q-Jc-bj-contactView {
        -webkit-flex: 0 0 250px;
        flex: 0 0 250px;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #00448b;
        margin-left: 0px;
    }

    .a-q-Jc-Lb-contactView {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-decoration: none;
        line-height: 1.21;
        letter-spacing: normal;
        color: #303031;
        margin-left: 88px;
    }

    .a-q-Jc-Pj-Ya-contactView:nth-of-type(even) {
        background-color: #f5f6f9;
    }

    .a-q-Jc-Lb-contactView.linkactive {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: right;
        color: #00448b;
    }

    .a-q-Jc-wg-contactView {
        text-decoration: none;
    }

    .suggestionCompany {
        width: 48px;
        height: 48px;
    }

    @media screen and (max-width: 991px) {
        .suggestions {
            display: none !important;
        }
    }

    @media screen and (max-width: 764px) {
        .companyDisplay {
            display: none !important;
        }
    }

    .textWhite {
        color: white;
    }

    .contactMediaView {
        font-size: 18px !important;
        padding-top: 3px !important;
        cursor: pointer;
        padding-left: 3px;
    }

    .mediaFacebook:hover {
        color: RGB(0, 132, 255) !important;
    }

    .mediaTwitter:hover {
        color: #1da1f2 !important;
    }

    .mediaLinkedIn:hover {
        color: #0077b5 !important;
    }

    .mediaSkype:hover {
        color: #0077b5 !important;
    }

    .verticalTab {
        height: 41px;
        display: flex;
        width: 100%;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 24px;
        position: relative;
        justify-content: center;
    }

    .contactSidebar {
        overflow-x: hidden;
        width: 312.7px;
        /* border-right: solid 1px #cdd2da; */
        background-image: linear-gradient(to bottom,
                #eaeaec,
                #f7f7f8 15%,
                #ffffff 34%,
                #ffffff 48%,
                #ffffff 62%,
                #f7f7f8 85%,
                rgba(234, 234, 236, 0.8));
    }

    .contactTitle {
        text-align: center;
        display: block;
        color: #fff;
    }

    .elTab {
        overflow-x: hidden !important;
    }

    .editProfile {
        float: right;
        right: 25px;
        top: 135px;
        position: absolute;
        color: #ffffff;
        border-radius: 50px;
        width: 112.5px;
        height: 33.2px;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(0, 0, 0, 0.2);
    }

    .activityContact {
        width: 35px;
        height: 20px;
    }

    .contact-details-tab-view.el-tabs--border-card>.el-tabs__header {
        background-color: #fff !important;
        border-right: none !important;
        color: #00448b;
    }

    .contact-details-tab-view .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        border-right-color: #ffffff !important;
        border-left-color: #ffffff !important;
        border-bottom-color: #00448b;
    }

    .contact-details-tab-view .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        color: #00448b !important;
    }

    .contact-details-tab-view .el-tabs__item {
        color: #303031 !important;
    }

    .el-main.contactTabs {
        padding-top: 0px !important;
        padding-left: 6px !important;
        margin-left: -2px;
        border-left: solid 1px #cdd2da;
        padding-right: 20px !important;
        padding-bottom: 20px !important;
    }

    .email-ul.dc-menu--horizontal {
        height: 42px;
        background-color: #f5f6f9;
    }

    .email-ul.dc-menu--horizontal>.dc-menu-item {
        height: 42px !important;
        line-height: 42px !important;
        margin: 0;
    }

    .email-ul .nav-link {
        height: 42px !important;
        /* background-color: #f5f6f9; */
    }

    .email-ul .nav-link:hover {
        background-color: none !important;
    }

    .email-inputs {
        padding-left: 100px;
        padding-right: 100px;
    }

    .aboutHeading {
        display: flex;
        width: 100%;
        padding-top: 8px;
        padding-left: 22px;
    }

    input[type="file"] {
        display: none;
    }

    .el-main.contactTabs {
        padding-top: 0px !important;
        padding-left: 6px !important;
        margin-left: -2px;
        border-left: solid 1px #cdd2da;
        padding-right: 20px !important;
        padding-bottom: 20px !important;
    }

    .contactSidebar {
        border-right: 0px solid #94b3f0 !important;
    }

    .qrcode-whole-div .qrcode-block-view {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #00448b;
        background: #d6e2ef;
        margin: 0 auto;
    }

    .qrcode-content-view {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 15px 5px 5px !important;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content {
        top: 10px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav .el-tabs__active-bar {
        height: 3px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav-scroll {
        padding: 0 8px !important;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav .el-tabs__item {
        padding: 2px 20px;
        height: 45px;
        line-height: 45px;
    }

    .nav-tabs.nav-businessprofile .nav-link.active,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link {
        color: #00448b;
        background-color: transparent;
    }

    .nav-tabs.nav-businessprofile .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link:not(.dropdown-toggle):after {
        background-color: transparent !important;
        content: none !important;
    }

    .nav.nav-tabs.nav-businessprofile {
        background: transparent;
        border-radius: 0px 0px 0px 0px;
    }

    .nav-tabs.nav-businessprofile .nav-link.active {
        overflow: visible;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover,
    .nav-tabs.nav-businessprofile .nav-link:focus {
        border-color: #00448b;
        background-color: #00448b;
        color: #fff !important;
    }

    .nav-tabs.nav-businessprofile .nav-link {
        border: 1px solid #4e5764;
        position: relative;
        display: block;
        height: 48px !important;
        margin-right: 10px;
        line-height: 48px;
        border-radius: 12px;
        margin-right: 10px;
        color: #4e5764
    }

    .nav-tabs.nav-businessprofile .nav-link.active,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link {
        border-color: #00448b;
        background-color: #00448b;
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link img {
        display: inline-block;
        text-align: center;
        margin: 8px auto 6px;
    }

    .nav-tabs.nav-businessprofile .nav-link i {
        display: inline-block;
        text-align: center;
        margin: 12px auto 6px;
        font-size: 16px !important;
        width: 42px;
        height: 14px;
        line-height: 14px;
        color: #4e5764;
    }

    .nav-tabs.nav-businessprofile .nav-link.active i,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link i {
        color: #fff !important;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover i,
    .nav-tabs.nav-businessprofile .nav-link:focus i {
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link h6 {
        display: inline-block;
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        color: #303031;
    }

    .nav-tabs.nav-businessprofile .nav-link.active h6,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link h6 {
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover h6,
    .nav-tabs.nav-businessprofile .nav-link:focus h6 {
        color: #fff;
    }

    .tab-content.profile-tab-content {
        padding: 10px 0px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        margin: 0 auto;
        width: 100%;
        font-weight: 600;
        font-size: 14px;
    }

    .tabs.tabs-style-iconbox {
        background: rgba(255, 255, 255, 0.4);
    }

    .tabs.tabs-style-iconbox {
        text-align: center;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: flex;
        margin: 0 auto;
        padding: 0;
        max-width: 1200px;
        list-style: none;
        -ms-box-orient: horizontal;
        -ms-box-pack: center;
        -webkit-flex-flow: row wrap;
        -moz-flex-flow: row wrap;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
    }

    .tabs.tabs-style-iconbox li {
        position: relative;
        z-index: 1;
        display: block;
        margin: 0;
        text-align: center;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .tabs.tabs-style-iconbox li.tab-current {
        z-index: 100;
    }

    .tabs.tabs-style-iconbox a {
        position: relative;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2.5;
        text-decoration: none;
        outline: none;
        width: 100%;
    }

    .tabs.tabs-style-iconbox li a {
        overflow: visible;
        padding: 2em 0;
        line-height: 1;
        -webkit-transition: color 0.2s;
        transition: color 0.2s;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        color: #74777b;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        background: #fff;
        box-shadow: -1px 0 0 #fff;
    }

    .tabs.tabs-style-iconbox .icon::before {
        display: block;
        margin: 0 0 0.25em 0;
    }

    .tabs.tabs-style-iconbox a span {
        vertical-align: middle;
        font-size: 0.75em;
    }

    .tabs.tabs-style-iconbox li a span {
        font-weight: 700;
        font-size: 0.7em;
    }

    .tabs.tabs-style-iconbox li.tab-current a::after,
    .nav-tabs .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs .nav-item.show .nav-link:not(.dropdown-toggle):after {
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -10px;
        width: 0;
        height: 0;
        border: solid transparent;
        border-width: 10px;
        border-top-color: #00448b;
        content: "";
        pointer-events: none;
        background-color: transparent !important;
    }

    .cover-card {
        position: relative;
        display: block;
        min-width: 0;
        word-wrap: break-word;
        background-color: transparent;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        border: 1px solid transparent;
        border-radius: 0rem;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        height: 150px;
    }

    .cover-card {
        margin-bottom: 2.143rem;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .cover-card-img-top {
        width: 100%;
        border-radius: 15px;
        vertical-align: middle;
        border-style: none;
    }

    .cover-card-block.wall-person-info {
        position: relative;
        padding: 1.429rem 0rem 0rem 0rem;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        text-align: center;
    }

    .wall-person-info .person-avatar {
        position: relative;
        top: -70px;
        width: 110px;
        height: 110px;
        text-align: center;
        display: inline-block;
        white-space: nowrap;
        vertical-align: bottom;
        border-radius: 1000px;
    }

    .pro-img-bordered {
        padding: 3px;
        border: 1px solid #e0e0e0;
    }

    /* .person-avatar img {
    width: 100%;
    max-width: 100%;
    height: auto;
    border: 0 none;
    border-radius: 1000px;
    margin: 0px auto;
} */

    .person-avatar .businesslogoimg {
        width: 102px;
        max-width: 102px;
        height: 102px;
        border: 0 none;
        border-radius: 1000px;
        margin: 0px auto;
    }

    .profile-list.business-list-info {
        flex-flow: row wrap;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;
        flex: 0 0 auto;
        padding: 15px 0;
        max-height: none !important;
    }

    .profile-list.business-list-info .profile-list-item {
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;
        min-width: 120px;
        min-height: 120px;
        width: 120px;
        height: 120px;
        padding: 10px 0;
        margin: 8px 16px;
        border-radius: 8px;
        cursor: pointer;
    }

    .profile-list.business-list-info .profile-list-item .profile-wrapper {
        font-size: 100px !important;
        width: 100px !important;
        height: 100px !important;
        min-width: 100px !important;
        min-height: 100px !important;
        line-height: 82px !important;
        text-align: center;
    }

    .profile-list.business-list-info .profile-list-item img.profile-images {
        font-size: 85px !important;
        width: 85px !important;
        height: 85px !important;
        min-width: 85px !important;
        min-height: 85px !important;
        line-height: 85px !important;
        display: inline-block;
        margin: 0 auto;
    }

    .profile-name {
        padding: 8px 5px 0;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        color: #fff;
    }



    .a-q-Jc-Pj-Ya-editBusinessView {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        line-height: 30px;
    }

    .a-q-Jc-Pj-Ya-editBusinessView {
        line-height: 25px;
        padding: 10px 10px 10px 3px;
        border-bottom: solid 1px transparent;
    }

    .a-q-Jc-bj-editBusinessView {
        -webkit-flex: 0 0 190px;
        flex: 0 0 190px;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #00448b;
        margin-left: 13px;
    }

    .a-q-Jc-Lb-editBusinessView {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-decoration: none;
        line-height: 1.21;
        letter-spacing: normal;
        color: #303031;
        margin-left: 88px;
    }

    .a-q-Jc-Pj-Ya-editBusinessView:nth-of-type(even) {
        background-color: #f5f6f9;
    }

    .a-q-Jc-Lb-editBusinessView.linkactive {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: right;
        color: #00448b;
    }

    .a-q-Jc-wg-editBusinessView {
        text-decoration: none;
    }

    .connectionbox {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0;
        margin: 0;
    }

    .connection_pic {
        padding-right: 1rem;
    }

    .connection_pic img {
        width: 25px;
        height: 25px;
    }

    .connection_details {
        line-height: 0;
        text-align: center;
    }

    .connection_details .count {
        display: block;
        font-size: 14px;
        font-weight: 800;
        line-height: 1.5rem;
        -webkit-transition: color .3s ease;
        transition: color .3s ease;
        color: #fff;
    }

    .connection_details .count-title {
        width: 100px;
        margin-top: 1px;
        display: inline-block;
        font-size: 14px;
        line-height: 1rem;
        font-weight: 600;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/BusinessProfile.vue